export const SET_MYALERT = 'SET_MYALERT';
export const REMOVE_MYALERT = 'REMOVE_MYALERT';

export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const USER_LOADED = 'USER_LOADED';
export const AUTH_FAILURE = 'AUTH_FAILURE';

export const MY_QUIZZES_SUCCESS = 'MY_QUIZZES_SUCCESS';
export const MY_QUIZZES_FAILURE = 'MY_QUIZZES_FAILURE';

export const VIEW_QUIZ_SUCCESS = 'VIEW_QUIZ_SUCCESS';
export const VIEW_QUIZ_FAILURE = 'VIEW_QUIZ_FAILURE';

export const VIEW_QUIZ_REPORT_SUCCESS = 'VIEW_QUIZ_REPORT_SUCCESS';
export const VIEW_QUIZ_REPORT_FAILURE = 'VIEW_QUIZ_REPORT_FAILURE';

export const GET_QUIZ_TEST_SUCCESS = 'GET_QUIZ_TEST_SUCCESS';
export const GET_QUIZ_TEST_FAILURE = 'GET_QUIZ_TEST_FAILURE';

export const QUIZ_RESULT_SUCCESS = 'QUIZ_RESULT_SUCCESS';
export const QUIZ_RESULT_FAILURE = 'QUIZ_RESULT_FAILURE';

export const CLEAR_QUIZ = 'CLEAR_QUIZ';

export const LOADIND_STATUS = 'LOADIND_STATUS';

export const LOGOUT = 'LOGOUT';
